import { type ComponentPropsWithoutRef, forwardRef } from 'react';

type ExternalLinkProps = ComponentPropsWithoutRef<'a'>;

const IN_PLACE_HREF = /^(mailto|tel):/i;

// mailto:, tel: and downloads navigate in place; a new tab would only be left blank.
const opensInPlace = ({ href, download }: ExternalLinkProps) => (download !== undefined && download !== false) || IN_PLACE_HREF.test(href ?? '');

const ExternalLink = forwardRef<HTMLAnchorElement, ExternalLinkProps>((props, ref) => {
  const newTabProps = opensInPlace(props) ? {} : { target: '_blank', rel: 'noopener noreferrer' };

  return <a ref={ref} {...newTabProps} {...props} />;
});
ExternalLink.displayName = 'ExternalLink';

export { ExternalLink, type ExternalLinkProps };
